import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_WEEKDAY_BOOKING_DISCOUNT, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemWeekdayBookingDiscountMaybe = ({ lineItems, intl }) => {
  const item = lineItems.find(i => i.code === LINE_ITEM_WEEKDAY_BOOKING_DISCOUNT && !i.reversal);
  if (!item) {
    return null;
  }
  const raw = item.percentage;
  const pct =
    raw != null ? Math.abs(Number(typeof raw.valueOf === 'function' ? raw.valueOf() : raw)) : null;
  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        {pct != null && Number.isFinite(pct) ? (
          <FormattedMessage id="OrderBreakdown.weekdayBookingDiscount" values={{ percent: pct }} />
        ) : (
          <FormattedMessage id="OrderBreakdown.weekdayBookingDiscountFallback" />
        )}
      </span>
      <span className={css.itemValue}>{formatMoney(intl, item.lineTotal)}</span>
    </div>
  );
};

LineItemWeekdayBookingDiscountMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemWeekdayBookingDiscountMaybe;
